import React, { useState } from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../../components/Button/FormSubmitButton';
import { Modal } from '../../../../components/Modal/Modal';
import DeleteModal from '../../../../components/Modal/ModalActions/DeleteModal/DeleteModal';

const DeleteAccount = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Container>
      <Box>
        <BoxTextArea>
          <BoxBoldText>Delete Account</BoxBoldText>
          <BoxText>
            Permanently delete your account and all data associated with it.
          </BoxText>
        </BoxTextArea>

        <FormSubmitButton
          onClick={() => setShowModal(true)}
          btnType='button'
          className='red fit'
        >
          Delete Account
        </FormSubmitButton>
      </Box>
      <Modal showModal={showModal} setShowModal={setShowModal}>
        <DeleteModal />
      </Modal>
    </Container>
  );
};

export default DeleteAccount;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Box = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 28px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};

  @media (max-width: 884px) {
    background-color: white;
  }
`;

const BoxTextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const BoxBoldText = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
`;

const BoxText = styled.div`
  gap: 20px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 14px;
  font-weight: 500;
  /* line-height: 16px; */
`;
